module.exports = __webpack_public_path__ + "img/heart-beat-circle.d6c414ef.png";